import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 14l5-5 5 5z"
}), 'ArrowDropUp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDropUp.js
// module id = 2093
// module chunks = 2